import type { Components, Theme } from '@mui/material/styles';

import { borders } from '@/theme/constants';
import { createDirectionalSpacing } from '@/utils/createDirectionalStyles';

const MuiTextField: Components<Theme>['MuiTextField'] = {
  styleOverrides: {
    root: ({ theme: { spacing, palette, direction } }: { theme: Theme }) => ({
      '& .MuiInputBase-root': {
        paddingTop: 0,
        paddingBottom: 0
      },
      '& .MuiInputBase-root .MuiInputBase-input': {
        height: 'unset',
        fontSize: spacing(1.75),
        lineHeight: spacing(3),
        padding: createDirectionalSpacing(direction === 'rtl', spacing)(1, 0.75, 1, 1),
        caretColor: palette.primary.main
      },
      '& .MuiInputBase-input::placeholder': {
        color: palette.grey[600],
        opacity: 1,
        letterSpacing: spacing(-0.015)
      },
      '& .MuiInputBase-root fieldset': {
        border: borders.half,
        borderColor: palette.grey[400]
      },
      '& .MuiInputBase-root.Mui-focused fieldset': {
        border: borders.half,
        borderColor: palette.primary[700]
      },
      '& .MuiInputBase-root.Mui-focused:hover fieldset': {
        border: borders.half,
        borderColor: palette.primary[700]
      },
      '& .MuiInputBase-root:hover fieldset': {
        border: borders.half,
        borderColor: palette.primary[700]
      }
    })
  },
  variants: [
    {
      props: { size: 'small' },
      style: ({ theme: { spacing } }) => ({
        '& .MuiInputBase-root .MuiInputBase-input': {
          fontSize: spacing(1.5),
          lineHeight: spacing(2)
        }
      })
    }
  ]
};

export default MuiTextField;
